import { InputAdornment, TextField } from '@mui/material';
import React from 'react';
import { FiSearch } from 'react-icons/fi';
import { AppColors } from '../Utils/helper/AppColors';

// if needed more will add here { } mapping for variant types accordingly

export default function SearchBar(props) {
	const {
		placeholder = 'Search',
		width = '100%',
		variant = 'default', // "default" or "small" (or other variants can be added)
		color,
		bgColor,
		search,
		setSearch,
		borderRadius,
		...rest
	} = props;

	return (
		<TextField
			sx={theme => ({
				width: width,
				'& .MuiOutlinedInput-root': {
					backgroundColor: bgColor,
					borderRadius:  borderRadius ||  '10px',
					height: variant === 'default' ? '38px' : '30px',
					minHeight: '30px',

					'& fieldset': {
						border: 'none', 
					},

					'& .MuiOutlinedInput-input': {
						fontSize: variant === 'default' ? '1rem' : '0.8rem',
						backgroundColor: 'transparent',
						'&::placeholder': {
							fontSize: variant === 'default' ? '1rem' : '0.8rem',
							color: color ,
						},
					},
				},
			})}
			fullWidth
			size="small"
			placeholder={placeholder}
			InputProps={{
				endAdornment: (
					<InputAdornment position="end">
						<FiSearch color={color} size={variant === 'default' ? 15.37 : 15.37} />
					</InputAdornment>
				),
			}}
			value={search}
			onChange={(e) => setSearch(e.target.value)}
			{...rest}
		/>
	);
}
